<div class="container">
  <header>
    <h1>Login</h1>
    <button mat-icon-button (click)="sidenav.controller.close()">
      <mat-icon>close</mat-icon>
    </button>
  </header>

  <form [formGroup]="form" (submit)="login()">
    <div class="input-field">
      <input class="input" placeholder="Username" formControlName="user" />
      <img src="/assets/home/user.png" />
    </div>
    <p class="error" *ngIf="showFieldError('user')">
      Username is a required field
    </p>
    <div class="input-field">
      <input
        type="password"
        class="input"
        placeholder="Password"
        formControlName="password"
      />
      <img src="/assets/home/password.png" />
    </div>
    <p class="error" *ngIf="showFieldError('password')">
      Password is a required field
    </p>
    <p class="forgot-password" (click)="forgotPassword()">
      Forgot your password?
    </p>
    <button mat-raised-button color="accent" type="submit">Login</button>
    <button mat-button type="button" (click)="registerNewAccount()">
      Register new account
    </button>
    <div
      style="
        display: flex;
        justify-content: center;
        margin-top: 5px;
        margin-bottom: 30px;
      "
    >
      <a
        href="/assets/politica-cookies.html"
        target="_blank"
        rel="noopener noreferrer"
        style="color: white"
      >
        Cookies Policy
      </a>
    </div>
  </form>

  <footer>
    <hr />
    <small>
      Login Problems? Contact us at intelligence.agency@wilsonsons.com.br
    </small>
  </footer>
</div>
